module.exports = __webpack_public_path__ + "media/LACHSONG_AREK.319cbc97.mp3";